import { NgModule } from '@angular/core';
import {
  StoryblokEditableDirective
} from '~app/modules/storyblok/directives/storyblok-editable/storyblok-editable.directive';

@NgModule({
  exports: [StoryblokEditableDirective],
  declarations: [StoryblokEditableDirective],
})
export class StoryblokEditableModule {
}
